// Registers the Invyt PWA service worker (see public/service-worker.js).
// Calls `onUpdate` when a NEW build's service worker takes over an already-
// controlled page, so the app can prompt the user to refresh.
export function registerServiceWorker(onUpdate) {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            // "installed" + an existing controller ⇒ this is an update, not a
            // first install ⇒ a newer bundle is ready.
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              if (typeof onUpdate === "function") onUpdate();
            }
          });
        });
      })
      .catch(() => {});

    // Re-check for a new build when the user returns to the tab.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        navigator.serviceWorker
          .getRegistration()
          .then((r) => r && r.update())
          .catch(() => {});
      }
    });
  });
}
